import { Injectable } from '@angular/core'
import { MatSnackBar, MatSnackBarVerticalPosition } from '@angular/material/snack-bar'
import { SnackbarBaseService } from '@megaphone/bases'
import { TranslateService } from '@ngx-translate/core'

@Injectable()
export class CloudSnackbarService extends SnackbarBaseService {
  constructor(private _snackBar: MatSnackBar, private _translateService: TranslateService) {
    super()
  }

  override showSnackBar(
    state: 'success' | 'error' | 'noChange' | 'copied',
    message = '',
    verticalPosition: MatSnackBarVerticalPosition = 'bottom',
  ) {
    let panelClass: string[]
    let duration = 6000
    let status = ''

    switch (state) {
      case 'noChange':
        status = this._translateService.instant('NOTHING_CHANGE')
        break
      case 'error':
        status = this._translateService.instant('ERROR_UPDATE')
        panelClass = ['danger']
        duration = 20000
        break
      case 'copied':
        status = this._translateService.instant('ELEMENT_COPIED')
        verticalPosition = 'top'
        duration = 1600
        break
      default:
        status = this._translateService.instant('SUCCESSFULL_UPDATE')
    }

    if (message) message = this._translateService.instant(message)

    const finalMessage = `${status} ${message}`
    this._snackBar.open(finalMessage, 'ok', {
      duration: duration,
      verticalPosition: verticalPosition,
      panelClass: panelClass,
    })
  }
}
